import { type FC } from 'react'
import { useMeetingWorkflowLauncher } from './useMeetingWorkflowLauncher'
import { WorkflowsMenu } from './WorkflowsMenu'

export const MeetingWorkflowsMenu: FC = () => {
  const launcher = useMeetingWorkflowLauncher()
  return <WorkflowsMenu launcher={launcher} />
}
